class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartItems = this.querySelector('cart-drawer-items');
  }

  getSectionsToRender() {
    return this.cartItems.getSectionsToRender();
  }

  renderContents(parsedState) {
    this.cartItems.renderSections(parsedState);

    setTimeout(() => {
      this.cartItems = this.querySelector('cart-drawer-items');

      this.classList.toggle('is-empty', this.cartItems.classList.contains('is-empty'));
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'header-cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'navigation-cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
